import { AnyAction } from 'redux'
import requestStatuses from '@cinch/oxd-utils/request-status/src'
import {
  DELIVERY_ADDRESS_INPUT,
  REQUEST_DELIVERY_SLOTS,
  RECEIVE_DELIVERY_SLOTS,
  ERROR_DELIVERY_SLOTS,
  SELECT_DELIVERY_SLOT,
} from '../types'

export interface DeliveryAddress {
  addressLine1: string
  addressLine2: string
  city: string
  county: string
  postCode: string
  deliveryInstructions?: string
}

export interface DeliverySlot {
  start: number
  end: number
  available: boolean
  date?: string
}

export interface DeliverySlotResponse {
  [key: string]: DeliverySlot[]
}

export interface DeliveryState {
  deliveryAddress?: DeliveryAddress
  deliverySlots?: DeliverySlotResponse
  deliverySlotsRequestStatus: string
  deliverySlotsRequestError?: string
  selectedDeliverySlot?: DeliverySlot
}

export const initialState: DeliveryState = {
  deliverySlotsRequestStatus: requestStatuses.INITIAL,
}

const appendDateStringToDeliverySlots = (slots: DeliverySlotResponse): DeliverySlotResponse =>
  Object.entries<DeliverySlot[]>(slots).reduce(
    (carry, entry) => ({
      ...carry,
      [entry[0]]: entry[1].map<DeliverySlot>((slot) => ({ ...slot, date: entry[0] })),
    }),
    {},
  )

export default function deliveryReducer(state = initialState, action: AnyAction): DeliveryState {
  switch (action.type) {
    case DELIVERY_ADDRESS_INPUT:
      return {
        ...state,
        deliveryAddress: action.payload,
      }
    case REQUEST_DELIVERY_SLOTS:
      return {
        ...state,
        deliverySlotsRequestStatus: requestStatuses.PENDING,
      }
    case RECEIVE_DELIVERY_SLOTS:
      return {
        ...state,
        deliverySlots: appendDateStringToDeliverySlots(action.payload),
        deliverySlotsRequestStatus: requestStatuses.SUCCESS,
      }
    case ERROR_DELIVERY_SLOTS:
      return {
        ...state,
        deliverySlotsRequestError: action.payload,
        deliverySlotsRequestStatus: requestStatuses.ERROR,
      }
    case SELECT_DELIVERY_SLOT: // TODO: use local component state?
      return {
        ...state,
        selectedDeliverySlot: action.payload,
      }
    default:
      return state
  }
}
